// Dispositions a reviewer can actually assign. Anything else stored on a
// compliance transaction (the model's 'pending' default, null, legacy text)
// means the charge has not been decided yet.
export const REAL_DISPOSITIONS = ['claim', 'exclude', 'void'];

export const isRealDisposition = (value) => REAL_DISPOSITIONS.includes(value);

// Preselection for the review card: keep a real stored choice, otherwise start
// from Claim so a save can never write the placeholder back.
export const resolveDisposition = (stored) => (isRealDisposition(stored) ? stored : 'claim');

// A charge still owed a human decision: never reviewed, or reviewed but saved
// without a real disposition (a state older builds could produce).
export const needsDisposition = (transaction) =>
  transaction.review_status === 'pending' || !isRealDisposition(transaction.disposition);
